import { FormFieldTypes } from "../../../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/forms/libs/data/ValidationTypes";

const initState = {
    sessionNumbers: 0,
    seatsNumber: null
};

export const NoOfSeatsFormData = {
    name: "NoOfSeatsFormData",
    initialState: initState,
    section: [
        {
            title: "No of seats Information Section",
            row: {},
            style: {
                sectionStyle: "verticle-form mb-3 form-card row",
            },
            fields: [
                {
                    id: "sessionNumbers",
                    label: "No. of sessions",
                    Field_Name: "No. of sessions",
                    fieldType: FormFieldTypes.NUMERIC,
                    dataField: "sessionNumbers",
                    fieldSetting: {
                        placeholder: "Please Enter Name",
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-lg-4 col-md-4 validation-left-0 mb-2 mt-2",
                    },
                },
                {
                    id: "seatsNumber ",
                    label: "No. of seats",
                    Field_Name: "No. of seats",
                    fieldType: FormFieldTypes.NUMERIC,
                    dataField: "seatsNumber",
                    fieldSetting: {
                        placeholder: "Please Enter Name",
                        allowSpace: true,
                    },
                    style: {
                        containerCss: "col-lg-4 col-md-4 validation-left-0 mb-2 mt-2",
                    },
                },
                {
                    id: "joiningDate",
                    label: "Deadline",
                    Field_Name: "Joining Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "joiningDate",
                    fieldSetting: {
                        allowSpace: true,
                        placeholder: "Select",
                    },
                    style: {
                        containerCss:
                            "col-lg-4 col-md-4 validation-left-0 blank-field-custom-grid",
                    },
                },
            ],
        },
    ],
    formSetting: {
        isViewOnly: false,
    },
};
